export default __webpack_public_path__ + "static/media/ProvidedHousingIcon.9b994b4e.svg";